import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { adminLogService } from "services/adminLog.service";
import authStore from "stores/auth/AuthStore";
import { AdminLog } from "types/adminLog.type";

class HistoryStore {
  logs: AdminLog[] = [];
  total = 0;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchLogs(page = 1, limit = 10, filters = {}) {
    if (!authStore.isAuthenticated()) return;

    this.loading = true;
    try {
      const { logs, total } = await adminLogService.getAll(
        page,
        limit,
        filters
      );
      runInAction(() => {
        this.logs = logs;
        this.total = total;
      });
      console.log("logs =>", logs);
    } catch (error) {
      toast.error("Erreur lors du chargement de l'historique");
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async getLogById(id: number) {
    try {
      const log = await adminLogService.getById(id);
      return log;
    } catch (error) {
      toast.error("Erreur lors de la récupération du log");
      throw error;
    }
  }

  async deleteLog(id: number) {
    try {
      await adminLogService.delete(id);
      runInAction(() => {
        this.logs = this.logs.filter((log) => log.id !== id);
        this.total = this.total - 1;
      });
      toast.success("Log supprimé !");
    } catch (error) {
      toast.error("Erreur lors de la suppression du log");
    }
  }
}

const historyStore = new HistoryStore();
export default historyStore;
